import React, { Component } from 'react';
import _ from 'lodash';
import { Message, Header, Container } from 'semantic-ui-react';
import StatusHelper from '../../../status-helper';

class ProblemsSection extends Component
{
    formatIssues()
    {
        const report    = this.props.report,
            errorCount  = _.get( _.keys( report.data.info.errors ), 'length', 0 );

        return _.map(
            _.concat( _.values( report.data.info.errors ), _.values( report.data.info.warnings ) ),
            ( issue, index ) => {
                return (
                    <Message
                    key={index}
                    error={( index < errorCount )}
                    warning={( index >= errorCount )}
                    content={issue.message}
                    icon={StatusHelper.getStatusIconName( ( index < errorCount ) ? 'error' : 'warning' )}
                    size={'large'}
                    />
                );
            }
        );
    }


    hasIssues()
    {
        const report = this.props.report;

        return (
            ( _.get( _.keys( report.data.info.errors ), 'length', 0 ) > 0 ) ||
            ( _.get( _.keys( report.data.info.warnings ), 'length', 0 ) > 0 )
        );
    }


   render()
    {
        if( this.hasIssues() === false )
        {
            return null;
        }

        return (
            <Container className='Problems'>
                <Header size={`large`}>Issues Detected</Header>
                {this.formatIssues()}
            </Container>
        );
    }
}

export default ProblemsSection;




// WEBPACK FOOTER //
// ./src/lib/components/PackageView/Sections/Problems.js